<div class="container">
  <div class="langs flex flex-wrap flex-center gap-36 sm:gap-40 py-20 sm:px-50">
    @for (item of env.dataEnv().languageList; track item) {
      <div class="cursor-pointer" [title]="item.short" (click)="changeLanguage(item.short)">
        @let lang = item.short === ROOT_LANG ? '' : '/' + item.short;
        @let url =  seo.domain() + lang + (currentPath() ? '/' + currentPath() : '');
        <a class="lang-item rounded-full pointer-events-none" [href]="url">
          <img class="rounded-full" [src]="'/assets/svg/lang/' + item.short + '.svg'" alt="">
        </a>
      </div>
    }
  </div>
  <div class="nav-container">
    <div class="nav">
      <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'about']">{{'link.about' | translate}}</a>
      <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'blog']">{{'link.blog' | translate}}</a>
      <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'banking']">{{'link.banking' | translate}}</a>
      <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'faq']">{{'link.faq' | translate}}</a>
      <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'terms-and-conditions']">{{'link.t&c' | translate}}</a>
      <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'bonus-terms']">{{'link.bonus-terms' | translate}}</a>
      <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'privacy-policy']">{{'link.pp' | translate}}</a>
      <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'cookie-policy']">{{'link.cookie-policy' | translate}}</a>
      <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'responsible-gaming']">{{'link.res-game' | translate}}</a>
      <a class="nav__item" target="_blank" href="https://www.samuraipartners.com">{{'link.affiliate' | translate}}</a>
      @if (installApp.isEnableNativeApp()) {
        <a class="nav__item" [routerLink]="['/' + lang.currentRouteLanguage, 'mobile-app']">{{'link.instal-app' | translate}}</a>
      }
    </div>
  </div>
</div>
